// TODO: REMOVE WHEN WE ADD EXPORT AND FILTERING
/* eslint-disable no-unused-vars */
import { getTestAttributes, groupBy } from '@chillibean/component-library';
import { FilterIndicator, Pill, Chip, Dropdown } from '@chillibean/component-library/legacy';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { useFilterParams } from '../../hooks';
import { setFilteringChips } from '../../redux/actions';
import { ACCORDION_TYPES } from '../modals';

function ActivitiesTableHeader(props) {
  const { onExport, toggleShowFilterModal } = props;

  const {
    activities: { loading },
    activitiesLength: { data: activitiesLength },
  } = useSelector((state) => state.activitiesReducer);
  const {
    filteringChips: { data: chips },
  } = useSelector((state) => state.filteringReducer);
  const dispatch = useDispatch();
  const { formatFiltersForParams } = useFilterParams();
  const activitiesCount = activitiesLength || 0;

  const chipsToFilterFormatted = (newChips) => {
    const groupedChips = Object.entries(groupBy(newChips, 'type'));
    return Object.fromEntries(
      groupedChips.map(([key, values]) => {
        let idValues = values.map(({ id }) => id);
        if (['date_to', 'date_from'].includes(key)) idValues = idValues.join('');
        return [key, idValues];
      }),
    );
  };

  const handleRemoveFilter = (chip) => {
    const chipsCopy = [...chips];
    const currentChipIndex = chipsCopy.findIndex((c) => c === chip);
    chipsCopy.splice(currentChipIndex, 1);
    dispatch(setFilteringChips({ data: chipsCopy }));
    const filterValues = chipsToFilterFormatted(chipsCopy);
    formatFiltersForParams({ values: filterValues });
  };

  const determineChipType = (type) => {
    switch (type) {
      case 'date_to':
      case 'date_from':
        return ACCORDION_TYPES.DATE;
      default:
        return ACCORDION_TYPES.CRITERIA;
    }
  };

  const renderFilterChips = useMemo(() => {
    if (!chips.length) return null;

    return (
      <ChipsContainer>
        {chips.map((chip) => {
          const accordionType = determineChipType(chip.type);
          return (
            <Chip
              key={`${chip.type}-${chip.id}`}
              active
              onClick={() => toggleShowFilterModal(accordionType)}
              onRemove={() => handleRemoveFilter(chip)}
              value={chip.value}
            />
          );
        })}
      </ChipsContainer>
    );
  }, [chips]);

  return (
    <HeaderContainer>
      <LeftItems {...getTestAttributes('activities-pill')}>
        <HeaderText>Activity</HeaderText>
        <Pill
          dataContext={pluralize('Activity', activitiesCount)}
          dataCount={activitiesCount.toString()}
          loading={loading}
        />
      </LeftItems>
      {/* TODO: UNCOMMENT WHEN WE ADD EXPORT AND FILTERING */}
      <RightItems>
        {renderFilterChips}
        <FilterContainer>
          <FilterIndicator handleClick={() => toggleShowFilterModal(ACCORDION_TYPES.CRITERIA)} value={chips.length} />
        </FilterContainer>
        <Dropdown
          icon="kebab"
          options={[
            {
              label: 'Export data',
              onSelect: onExport,
            },
          ]}
        />
      </RightItems>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  margin-bottom: 32px;
`;

const HeaderText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  size: 16px;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LeftItems = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const RightItems = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ChipsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  gap: 8px;

  > div.active {
    cursor: pointer !important;
  }
`;

ActivitiesTableHeader.propTypes = {
  onExport: PropTypes.func.isRequired,
  toggleShowFilterModal: PropTypes.func.isRequired,
};

export default ActivitiesTableHeader;
